export function clearIndexedDB() {
  indexedDB.deleteDatabase("UnityCache");
  indexedDB.deleteDatabase("/idbfs");
}
